import gql from 'graphql-tag';

export const GET_USER = gql`
  query GetUser {
    User {
      id
      name
    }
  }
`;

export const GET_LATEST_RELEASES = gql`
  query GetLatestReleases($limit: Int, $lastEvaluatedKey: String, $type: RELEASE_TYPE) {
    getLatestReleases(limit: $limit, lastEvaluatedKey: $lastEvaluatedKey, type: $type) {
      items {
        id
        titleLang
        bodyLang
        createdAt
        createdBy
        updatedAt
        imageUrls
        productTags
        type
        notes {
          titleLang
          showToCustomers
          imageUrls
        }
      }
      lastEvaluatedKey
    }
  }
`;

export const GET_RELEASE = gql`
  query GetRelease($id: String!) {
    getRelease(id: $id) {
      id
      titleLang
      bodyLang
      createdAt
      createdBy
      imageUrls
      notes {
        titleLang
        showToCustomers
        imageUrls
      }
      productTags
      type
      updatedAt
      repository
      triggerModal
    }
  }
`;
